<template>
  <div class="memories-page">
    <Countdown
      @update="countdown = null"
      v-if="countdown"
      v-model="countdown"
    />
    <div class="memories-page__header">
      <div class="heading">{{ activePage.heading_text }}</div>
      <p class="sub-heading">
        {{ activePage.intro_text }}
      </p>
      <ShareYourMemory />
    </div>
    <div class="memories-page__grid">
      <div ref="grid">
        <SearchInput v-model="search" />
        <Grid :items="memories" :pageSlug="pageSlug" />
        <infinite-loading :identifier="infiniteId" @infinite="fetchMemories">
          <div slot="no-more"></div>
          <div slot="no-results" class="no-results">Nothing found</div>
          <div slot="spinner">
            <Spinner />
          </div>
        </infinite-loading>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import _ from "lodash";
import ShareYourMemory from "@/components/Memory/ShareYourMemory";

export default {
  name: "MemoriesPage",
  metaInfo: {
    titleTemplate: "%s - Memories",
  },
  components: { ShareYourMemory },
  data() {
    return {
      search: "",
      memories: [],
      page: 1,
      infiniteId: +new Date(),
      pageIds: [],
      memoryPageDialog: false,
      moment: "shine",
      momentInterval: null,
      showTags: false,
      pageSlug: "stories",
      moments: [
        "shine",
        "come together",
        "soar",
        "rise to the occasion",
        "change the world",
        "celebrate",
      ],
      countdown: {
        id: 11,
        left_text: "Believe Beyond Boundaries\nsave the date 07.11.2020",
        right_text:
          "<div class='temp-presented-by'>Presented by\n<span class='temp-delta'></span> <span class='temp-novelis'></span></div>",
        release_date: "2020-07-11T19:00:00.000-04:00",
      },
    };
  },
  created() {
    this.startMomentRotator();
  },
  mounted() {
    this.setPageContext("stories", () => {
      this.fetchResource("Memory");
    });
  },
  methods: {
    startMomentRotator() {
      this.momentInterval = setInterval(() => {
        this.moment = _.sample(this.moments);
      }, 3000);
    },
    async fetchMemories($state) {
      const params = {
        page: this.page,
        query: this.search,
        page_slug: this.pageSlug,
      };
      const { data } = await this.$api.Memory.query(params);
      this.page += 1;
      const ids = this.memories.map((t) => t.id);
      const newData = data.filter((t) => !ids.includes(t.id));

      this.memories.push(...newData);

      if (data.length) {
        $state.loaded();
      } else {
        $state.complete();
      }
    },
    setInfiniteId: _.debounce(function () {
      this.page = 1;
      this.memories = [];
      this.infiniteId += 1;
    }, 300),
  },
  watch: {
    search() {
      this.setInfiniteId();
    },
  },
  beforeDestroy() {
    if (this.momentInterval) {
      clearInterval(this.momentInterval);
    }
  },
  computed: {
    ...mapState({
      introText: (state) => state.page.active?.intro_text,
    }),
  },
};
</script>

<style scoped lang="scss">
.memories-page {
  &__header {
    text-align: center;
    padding: 54px 15% 45px;

    .heading {
      font-weight: 800;
      font-size: 64px;
      line-height: 73px;
    }

    .sub-heading {
      font-size: 18px;
      line-height: 24px;
      margin: 15px 0 34px;
      color: black;
    }
  }

  &__grid {
    min-height: 200px;
    position: relative;
  }
}

@media screen and (max-width: 960px) {
  .memories-page {
    &__grid {
      margin-bottom: 40px;
    }
    &__header {
      padding: 40px;
      .heading {
        font-size: 43px;
        line-height: 44px;
      }
    }
  }
}
</style>
